<script setup lang="ts">
import { routeNames } from '@/constants/route-details.constant';

const route = useRoute();

const currentLabel = computed(() => {
  const name = route.name?.toString() as keyof typeof routeNames | undefined;
  return name && routeNames[name] ? routeNames[name].uiLabel : 'Dashboard';
});

</script>
<template>
  <div class="overflow-y-scroll h-screen flex-1">
    <slot></slot>
  </div>
</template>
